/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Privy_Status_LabelInputs */

const en_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protected by Privy`)
};

const de_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschützt durch Privy`)
};

const pt_br2_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protegido pela Privy`)
};

const tr_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy ile korunuyor`)
};

const zh_cn2_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 Privy 提供保护`)
};

const zh_hk2_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 Privy 提供保護`)
};

const ko_kr2_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy로 보호됨`)
};

const ru_ru2_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защищено Privy`)
};

const es_419_login_page_privy_status_label = /** @type {(inputs: Login_Page_Privy_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protegido por Privy`)
};

/**
* | output |
* | --- |
* | "Protected by Privy" |
*
* @param {Login_Page_Privy_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_privy_status_label = /** @type {((inputs?: Login_Page_Privy_Status_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Privy_Status_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_privy_status_label(inputs)
	if (locale === "de") return de_login_page_privy_status_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_privy_status_label(inputs)
	if (locale === "tr") return tr_login_page_privy_status_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_privy_status_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_privy_status_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_privy_status_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_privy_status_label(inputs)
	return es_419_login_page_privy_status_label(inputs)
});